export default "__VITE_ASSET__CHO0T5_y__"